import { Palmtree, GraduationCap, Home, LifeBuoy, Plane, Heart, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "@/App";

const goals = [
  { icon: Palmtree, title: "Retirement", copy: "Retire on your terms — not your employer's timeline.", span: "md:col-span-2", slug: "retirement" },
  { icon: GraduationCap, title: "Children's Education", copy: "Fund the dream school before the dream begins.", span: "", slug: "education" },
  { icon: Home, title: "Home Purchase", copy: "Turn years of rent receipts into keys of your own.", span: "", slug: "home" },
  { icon: LifeBuoy, title: "Emergency Fund", copy: "Six months of calm, parked and ready.", span: "", slug: "emergency" },
  { icon: Plane, title: "Vacation", copy: "Travel now — without borrowing from tomorrow.", span: "", slug: "vacation" },
  { icon: Heart, title: "Marriage", copy: "Celebrate big. Start debt-free.", span: "", slug: "marriage" },
];

export const Goals = () => (
  <section id="goals" data-testid="goals-section" className="bg-[#F4F0FF] py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow index="02" label="Goal-based investing" />
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-wealth mt-5 max-w-2xl">
            Inflation eats idle savings. <span className="italic text-wealth-light">We map money to life.</span>
          </h2>
        </div>
        <p className="max-w-sm text-base leading-relaxed text-wealth/60">
          Every rupee gets a job. We help you assign each goal a timeline, a
          target and an investment built to reach it.
        </p>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {goals.map((g, i) => (
          <Reveal key={g.slug} delay={i * 0.06} className={g.span}>
            <div
              data-testid={`goal-card-${g.slug}`}
              className="group h-full bg-bone border border-wealth/10 rounded-sm p-9 flex flex-col justify-between min-h-[220px] transition-[background-color,border-color] duration-500 hover:bg-wealth hover:border-wealth"
            >
              <g.icon
                size={30}
                strokeWidth={1.5}
                className="text-brand transition-transform duration-500 group-hover:-translate-y-1"
              />
              <div className="mt-10">
                <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight text-wealth group-hover:text-bone transition-colors duration-500">
                  {g.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-wealth/60 group-hover:text-bone/65 transition-colors duration-500">
                  {g.copy}
                </p>
              </div>
            </div>
          </Reveal>
        ))}

        <Reveal delay={0.36} className="md:col-span-2">
          <button
            data-testid="goal-card-custom"
            onClick={() => scrollToId("#consultation")}
            className="group w-full h-full min-h-[220px] bg-brand text-left rounded-sm p-9 flex flex-col justify-between transition-[background-color] duration-500 hover:bg-brand-light"
          >
            <span className="text-[11px] font-bold uppercase tracking-[0.26em] text-white/70">
              A different dream?
            </span>
            <span className="mt-8 flex items-end justify-between gap-6">
              <span className="font-display text-3xl md:text-4xl font-medium tracking-tight text-white">
                Let's map it together.
              </span>
              <ArrowRight size={30} className="text-white transition-transform duration-500 group-hover:translate-x-2" />
            </span>
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
